import { createSelector } from 'reselect';

const selectAccessHoursState = (state: any) => state.accessHoursState;

export const selectAccessHoursEvents = createSelector(
	[selectAccessHoursState],
	accessHoursState => accessHoursState
);
